export default __webpack_public_path__ + "static/media/full-logo-primary.c8837d74.svg";